import { render, staticRenderFns } from "./LivesMain.vue?vue&type=template&id=21edd71f"
import script from "./LivesMain.vue?vue&type=script&lang=js"
export * from "./LivesMain.vue?vue&type=script&lang=js"
import style0 from "./LivesMain.vue?vue&type=style&index=0&id=21edd71f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports